export class MdcDefaultSelectConfiguration {
  outlined?: boolean;
}
